export const firebaseConfig = {
    apiKey: "AIzaSyAFJKChP5W9B6EGkNK-792bwEHhkjGtk3s",
    authDomain: "codeyolo.firebaseapp.com",
    databaseURL: "https://codeyolo-default-rtdb.firebaseio.com",
    projectId: "codeyolo",
    storageBucket: "codeyolo.appspot.com",
    messagingSenderId: "794757651444",
    appId: "1:794757651444:web:3d36d8c53762ad8ffe37a1",
    measurementId: "G-YRMXR0G20Q"
};


// WEBPACK FOOTER //
// ./src/firebase/firebaseConfig.js